export default __webpack_public_path__ + "static/media/sterling.b23b2c8f.svg";